import type { ReactNode } from 'react';
import { Select } from '@viquard/doc-ui/components';
import type { CalendarGroup } from '../../types.js';
import { useCalendarMessages } from '../../i18n.js';
import { CrossPostList } from './CrossPostList.js';
import { FieldRow, Section } from './layout.js';
import { PRIVATE_GROUP_SENTINEL, buildGroupOptions } from './single-form-helpers.js';

export interface AudienceSectionProps {
  readonly groups?: readonly CalendarGroup[] | undefined;
  readonly groupId: string | null;
  readonly crossPosted: readonly string[];
  readonly onGroupIdChange: (next: string | null) => void;
  readonly onCrossPostedChange: (next: readonly string[]) => void;
}

export function AudienceSection(props: AudienceSectionProps): ReactNode {
  const messages = useCalendarMessages();
  const groupOptions = buildGroupOptions(props.groups, messages.composerPrimaryGroupNone);
  return (
    <Section title={messages.composerSectionAudience}>
      <div className="vq-cal__composer-grid vq-cal__composer-grid--2">
        <FieldRow
          label={messages.composerPrimaryGroupLabel}
          filled={props.groupId !== null}
        >
          <Select
            options={groupOptions}
            value={props.groupId ?? PRIVATE_GROUP_SENTINEL}
            onValueChange={(v) => {
              props.onGroupIdChange(v === PRIVATE_GROUP_SENTINEL ? null : v);
            }}
            size="md"
          />
        </FieldRow>
        {props.groups !== undefined && props.groups.length > 0 && (
          <FieldRow
            label={messages.composerCrossPostLabel}
            filled={props.crossPosted.length > 0}
          >
            <CrossPostList
              groups={props.groups}
              excludeId={props.groupId}
              value={props.crossPosted}
              onChange={props.onCrossPostedChange}
            />
          </FieldRow>
        )}
      </div>
    </Section>
  );
}
